import type { BadgeTone } from '@/components/dashboard/StatusBadge';

const PROPERTY_STATUS_LABEL_MAP: Record<string, string> = {
  active: 'Vacant',
  conditional: 'Pending lease',
  sold: 'Closed deal',
  leased: 'Leased',
  expired: 'Expired listing',
  suspended: 'On hold',
  terminated: 'Terminated',
};

const UNIT_STATUS_LABEL_MAP: Record<string, string> = {
  available: 'Available',
  leased: 'Leased',
};

function fallbackStatusLabel(status: string): string {
  return status.replace(/_/g, ' ').replace(/\b\w/g, (char) => char.toUpperCase());
}

export function propertyListingStatusLabel(status: string): string {
  return PROPERTY_STATUS_LABEL_MAP[status] ?? fallbackStatusLabel(status);
}

export function propertyListingStatusTone(status: string): BadgeTone {
  switch (status) {
    case 'active':
      return 'warning';
    case 'conditional':
      return 'info';
    case 'sold':
    case 'leased':
      return 'success';
    case 'suspended':
    case 'terminated':
      return 'danger';
    case 'expired':
      return 'neutral';
    default:
      return 'info';
  }
}

export function propertyVisibilityLabel(visibility: string): string | null {
  if (visibility === 'draft') {
    return 'Draft';
  }
  if (visibility === 'archived') {
    return 'Archived';
  }
  return null;
}

export function propertyVisibilityTone(visibility: string): BadgeTone {
  switch (visibility) {
    case 'draft':
      return 'warning';
    case 'archived':
      return 'danger';
    default:
      return 'neutral';
  }
}

export function unitStatusTone(status: string): BadgeTone {
  switch (status) {
    case 'available':
      return 'success';
    case 'leased':
      return 'neutral';
    default:
      return 'neutral';
  }
}

export function unitStatusLabel(status: string): string {
  return UNIT_STATUS_LABEL_MAP[status] ?? fallbackStatusLabel(status);
}
